<template>
  <div class="monthly-view">
    <header-vue />
    <section-vue />
    <footer-vue />
  </div>
</template>

<script>
import "../../../assets/css/styles.css";
import HeaderVue from "./Header.vue";
import SectionVue from "./Section.vue";
import FooterVue from "../../common/Footer.vue";
import { mapGetters, mapActions } from "vuex";
import { authMixin } from "../../../mixins/authMixin.js";

export default {
  mixins: [authMixin],
  computed: {
    ...mapGetters({
      getSelectedYear: "getSelectedYear",
      selectedProviderID: "getSelectedProviderID"
    })
  },
  components: {
    HeaderVue,
    SectionVue,
    FooterVue
  },
  methods: {
    ...mapActions({
      getYearlyAppointments: "getYearlyAppointments"
    })
  },
  created() {
    this.getYearlyAppointments(this.getSelectedYear);
  },
  watch: {
    selectedProviderID() {
      this.getYearlyAppointments(this.getSelectedYear);
    }
  }
};
</script>
